'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getProductIntentLink;

var _productIntentLinks = require('../constants/productIntentLinks');

var _productIntentLinks2 = _interopRequireDefault(_productIntentLinks);

var _isExternalLink = require('../utils/isExternalLink');

var _isExternalLink2 = _interopRequireDefault(_isExternalLink);

var _links = require('./links');

var _links2 = _interopRequireDefault(_links);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('utils/getProductIntentLink');

function getShortLink(intent) {
  if (intent && intent.indexOf(_links2.default.shortlink()) !== -1) {
    return intent;
  }
  return false;
}

function resolveProductIntentLink(intentKey) {
  var productIntentLink = (0, _isExternalLink2.default)(intentKey) ? _productIntentLinks2.default[intentKey] : getShortLink(intentKey) || _productIntentLinks2.default[intentKey];

  if (intentKey && !productIntentLink) {
    LOG.error('intent URL param passed to app was not recognized', {
      extra: { intentKey: intentKey }
    });
  }

  return productIntentLink;
}

function getProductIntentLink(intentKey, intentParams, portalId) {
  var productIntentLink = resolveProductIntentLink(intentKey);

  var intentRedirectHref = void 0;

  var linkType = typeof productIntentLink === 'undefined' ? 'undefined' : _typeof(productIntentLink);
  if (linkType === 'function') {
    if (intentKey && intentParams && intentParams.size > 0) {
      // new behaviour (are there other params beside the intent itself?
      intentRedirectHref = productIntentLink(portalId, intentParams);
    } else {
      // support for old behaviour (only the intent params found in the link)
      intentRedirectHref = productIntentLink(portalId);
    }
  } else if (linkType === 'string') {
    // for shortlinks
    intentRedirectHref = productIntentLink;
  }

  return intentRedirectHref;
}
module.exports = exports['default'];